import React, { Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as ConfigurationActions from "../../../store/configurationService/actions";
import { ApplicationState } from "../../../store";
import { breachServiceActive } from "../../../util/CommonBreach";
import LogoContainer from "../../common/LogoContainer";
import BreachesTab from "../BreachesTab";
import BreachHeaderText from "../BreachHeaderText";
import SearchBreachesHeader from "./SearchBreachesHeader";

function SearchBreaches() {
    const dispatch = useDispatch();
    const breachService = useSelector((state: ApplicationState) => (state.breachServiceState ? state.breachServiceState.breachService : null));
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    return (
        <Fragment>
            {breachServiceActive(breachService) ? (
                <div className=" row">
                    <BreachHeaderText />
                </div>
            ) : null}

            {!breachServiceActive(breachService) ? (
                <div className=" row">
                    <div className="col-xs-12 row">
                        <h1 className="title-page" id="breach-search-page" tabIndex={-1} style={{ color: "#00313c" }}>
                            Breach Search
                        </h1>
                        <LogoContainer internalPage={true} />
                    </div>
                </div>
            ) : null}
            <BreachesTab selectedTab="4" />
            <div className="row" id="content">
                <div className="col-xs-12 col-sm-12">
                    <div className="box">
                        <SearchBreachesHeader />
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default SearchBreaches;
